/**
 * @name 上传组件
 */
import base from '../../base';
import Table from './Table';

Table.install = function(Vue) {
  Vue.use(base);
  Vue.component(Table.name, Table);
};

export default Table;
